import { NormalizedCacheObject } from '@apollo/client';
import { ApolloClient, FetchPolicy } from '@apollo/client';
import { loader } from 'graphql.macro';
import { ApolloClientCache } from 'common-types';
import {
  IrrelevantAppsResponse,
  RawIrrelevantApp,
} from '../irrelevant-apps-types';

const query = loader('./get-irrelevant-apps-results.gql');

const getIrrelevantAppsResult = (
  client: ApolloClient<NormalizedCacheObject>,
) => {
  return {
    execute: async (
      getApplicationsInput: GetApplicationsInput,
    ): Promise<RawIrrelevantApp[]> => {
      const fetchPolicy: FetchPolicy = ApolloClientCache.NoCache;
      const results = await client.query<IrrelevantAppsResponse>({
        query,
        fetchPolicy,
        variables: { getApplicationsInput },
      });
      if (!results.data.getApplications) return [];
      return results.data.getApplications.applications;
    },
  };
};

export interface GetApplicationsInput {
  applicationFilters?: ApplicationsFilters[];
  irrelevancyFilters?: string[];
}

/** for filters */
export enum ApplicationsFilters {
  New = 'new',
  InDevelopment = 'updated',
  DeployedProd = 'deployedProd',
  ExternallyFacing = 'publicVisibility',
  Relevant = 'relevant',
  Irrelevant = 'Irrelevant',
}

/** filters for irrelevancy reasons */
export enum IrrelevantReason {
  Archived = 'Archived Repo',
  FailedClone = 'No Access for Cloning',
  NoFiles = 'No Relevant Files',
  LastCodeChange = 'No Code Changes in 6 Months',
  SetByClient = 'Repository has been set by client to be irrelevant',
}

export default getIrrelevantAppsResult;
